import { useEffect } from 'react';
import { USER_ID } from '../../../store/modules/user/user.constants';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';

export const useGetAccountDetails = (isNotNative: boolean): void => {
  const { userActions, tenantActions, facilityActions } = useActions();
  const localStorageService = useLocalStorage();
  const userID: number | null = localStorageService.get(USER_ID);

  useEffect(() => {
    if (userID) {
      userActions.getCurrentUser(userID);
      userActions.getRolesList();
      tenantActions.getTenantsList();
      if (!isNotNative) {
        userActions.getTimeZones();
        facilityActions.getGroups();
        facilityActions.getFacilities();
      }
    }
  }, []);
};

export default useGetAccountDetails;
